import { Component, OnInit } from '@angular/core';
import { CommanService } from 'src/app/shared/services/comman.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { BuyticketsService } from 'src/app/shared/services/buytickets.service';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
declare  var jQuery:  any;
declare  var $:  any;

@Component({
  selector: 'app-buytickets',
  templateUrl: './buytickets.component.html',
  styleUrls: ['./buytickets.component.scss']
})
export class BuyticketsComponent implements OnInit {
	is_authenticate_user: boolean = false;
	sponsorsList: any = "";
	matchticketList: any = "";

  slidesponsorConfig = {
		  //dots:false,
		  infinite: true,
		  arrows:false,
		  slidesToShow:5,
		  autoplay:true,
		  speed: 500,
		responsive: [{
		       
		      breakpoint: 1024,  
		      settings: {
		        slidesToShow: 5
		      }
		      },  
		      {
		      breakpoint: 992,  
		      settings: {
		        slidesToShow: 3
		      }
		      },
		      {
		      breakpoint: 767,  
		      settings: {
		        slidesToShow: 3
		      }

		    }]
		};

  constructor(
	private router: Router,
	public commanService: CommanService,
	public buyticketsService: BuyticketsService,
  	public authService: AuthService,) { }

  ngOnInit(): void {

	this.loginactivefunction();
	// if(this.authService.isLoggedIn == true)
    // {
    //   this.is_authenticate_user = true;
    //   //this.loginactivefunction();
    // }else{
	// this.router.navigate(['/singin']);
    // }
  	this.commanService.getSponsors().then((data) => {
	      this.sponsorsList = data;
	      //console.log(this.sponsorsList);
	    });
  }
  loginactivefunction(){
	this.buyticketsService.getMatchticket().then((data) => {
		this.matchticketList = data;
		console.log(this.matchticketList);
	  });
  }

}
